export default {
      id: "hamburger-open-usage",
      viewBox: "0 0 22 19",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#hamburger-open",
      toString: function () {
        return this.url;
      }
    }